/* //@ts-nocheck */
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import DialogUtil from "@banno/jha-wc/src/js/utils/dialog-util";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/jha-tooltip/jha-tooltip";
import { routingMixin } from "@jack-henry/web-component-router";
import Cookies from "js-cookie";
import { LitElement, css, html, nothing, PropertyValues } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Apis } from "../../utils/api-constants";
import { StatusConstants } from "../../utils/apiStatusConstants";
import { AppRouters } from "../../utils/app-router";
import {
  ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT,
  applyAdvancedTableHeaderLayout,
  decryptValue,
  getEnvApiUrl,
  isBusinessUnitAdminUserType,
  isEnterpriseAdminUserType,
  showToastMessage,
  stripAdvancedTableRedundantTitles,
  stringComparison,
  buildAdvancedTableJhaTooltipOverflowEscapeCss,
  buildAdvancedTableEllipsisColumnShadowCss,
  renderAdvancedTableEllipsisCell,
} from "../../utils/app-utils";
import {
  dateTimeColumnLabel,
  EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT,
  EFM_TIMEZONE_GRID_TABLE_STYLE,
  formatEpochSecondsForDisplay,
  normalizeEpochSeconds,
  orderLoadedRowsByEpoch,
  renderGridWithTimezoneBanner,
} from "../../utils/datetime-display";
import { GlobalVariables } from "../../utils/constants";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { deleteRequest, fixedEncodeURIComponent, getRequest, postRequest, putRequest } from "../../utils/jha-fetch";
import { WorkflowTemplateType } from "../../types/WorkflowTemplates/WorkflowTemplateType";
import { WorkflowTemplateVariable } from "../../types/WorkflowTemplates/WorkflowTemplateVariable";
import {
  BUILTIN_BUSUNIT_VARIABLE,
  BUILTIN_REGION_VARIABLE,
  getSyntheticBuiltinBusUnitVariableForApi,
  getSyntheticBuiltinRegionVariableForApi,
  mergeBuiltinBusUnitVariableForGenerateUi,
  mergeBuiltinRegionVariableForGenerateUi,
  templateEntityUsesBuiltinRegionVariable,
} from "../../utils/workflowTemplatePlaceholderSyntax";
import {
  businessUnitAdminCanGenerateFromTemplate,
  businessUnitAdminCanMutateTemplate,
  filterWorkflowTemplatesForBusinessUnitAdmin,
} from "../../utils/workflowTemplateAccess";
import "./WorkflowTemplateGenerateDialog";
import "../../Components/Loader";
import { jhaDropdownMenuPanelStyles, jhaDropdownMenuPanelStylesText } from "../../styles/jha-dropdown-menu-panel";

/**
 * API Request interface for workflow template search
 * Ensures type safety when making API calls
 */
interface WorkflowTemplateSearchRequest {
  templateName: string;
  sortColumn?: string;
  sortDescending?: boolean;
  pageKey?: number | string;
}

const WORKFLOW_TEMPLATE_ELLIPSIS_TITLE_COLUMN_IDS = new Set([
  "templateName",
  "description",
  "category",
]);

/** Action menu uses native title for dropdown hint and disabled Generate explanation. */
const WORKFLOW_TEMPLATE_PRESERVE_INNER_TITLE_COLUMN_IDS = new Set(["_actions"]);

@customElement("workflow-template-main-view")
export class WorkflowTemplateMainView extends (routingMixin(LitElement) as unknown as typeof LitElement) {
  static get is() {
    return "workflow-template-main-view";
  }

  @property({ attribute: false }) workflowTemplates: WorkflowTemplateType[] = [];

  static readonly styles = [jhaDropdownMenuPanelStyles, css`
    #workflowTemplatesMain {
      display: flex;
      flex-direction: column;
      padding: 24px;
      flex: 1;
      box-sizing: border-box;
      overflow: hidden;
      height: -webkit-fill-available;
    }

    #formCon {
      display: flex;
      flex-direction: row;
      gap: 15px;
      align-items: center;
      justify-content: space-between;
    }

    #table-container {
      display: flex;
      height: 100%;
    }

    #noData {
      display: flex;
      justify-content: center;
    }

    .table-header-container {
      width: 100%;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    .inputContainer {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    jha-form-row {
      align-items: baseline;
      justify-content: flex-end;
      flex: 1;
    }

    jha-table-header {
      width: 20vw;
    }

    jha-card {
      margin-top: 10px;
      flex: 1;
      overflow: hidden;
      margin-left: 0px;
      margin-right: 0px;
      padding: 5px;
    }

  `];

  @property({ type: Boolean }) isReadOnlyUser = false;
  @property({ type: Boolean }) isEnterpriseAdmin = false;
  @property({ type: Boolean }) isBusinessUnitAdmin = false;
  @property({ type: String }) loggedUserBu = "";

  /** Sets role flags from session cookies (call from connectedCallback so values match Workflow list views). */
  private refreshRoleFromCookies(): void {
    const userType = decryptValue(Cookies.get("userType") || "");
    const userRole = decryptValue(Cookies.get("userRole") || "");
    this.isEnterpriseAdmin = isEnterpriseAdminUserType(userType);
    this.isBusinessUnitAdmin = isBusinessUnitAdminUserType(userType);
    this.isReadOnlyUser = /readonly/i.test(userRole);
    this.loggedUserBu = (Cookies.get("businessUnit") || "").trim().toLowerCase();
  }
  /** Lowercase businessUnitId -> display name for the Visibility column */
  @state() private businessUnitsMap: Map<string, string> = new Map();
  @property() pageTitle = "Workflow Templates";
  @property({ type: Boolean }) searchWorkflowTemplate = false;
  @property({ type: Number }) pageLimit = 20;
  @property() sortColumnId = "";
  @property() sortDirection = "";
  @property({ type: Boolean }) apiLoading = false;
  @property({ type: Object }) advancedTableConfig = {
    filters: {},
    searchQuery: "",
    sort: { columnId: "updateDateTime", descending: true },
    columnOrder: [
      "templateName",
      "description",
      "createDateTime",
      "createdBy",
      "updateDateTime",
      "updatedBy",
      "category",
      "status",
      "_actions",
    ],
    apiTotal: 0,
    apiControlled: true,
    showSearchButton: false,
    activeProperty: undefined,
  };

  @property() nextPageKey = "";
  @property({ type: Boolean }) loadingMore = false;

  private static readonly TEMPLATE_SEEK_MAX_COUNT = 400;
  private _templatePageSyncTimer: ReturnType<typeof setInterval> | undefined;
  private _templatePagedFetchChain: Promise<void> = Promise.resolve();
  private _templateTablePaginationSyncBound = false;
  @property({ type: Array }) workflowFetchedTemplateData: any[] = [];
  @property() templateSearchName = "";

  @property({ type: Array })
  columns: Array<{
    label: string;
    id: string;
    sortBy?: boolean;
    dataType?: string;
    options: [];
    valueRenderer?: (val: any, row?: any) => any;
    valueFormatter?: (val: any, row?: any) => any;
  }> = [];

  private getMenuItemStyle(isActive: boolean): string {
    return isActive
      ? "opacity: 1; cursor: pointer;"
      : "opacity: 0.4; cursor: not-allowed;";
  }

  private getMenuItemLinkStyle(isActive: boolean): string {
    return isActive
      ? "color: inherit; cursor: pointer; pointer-events: auto;"
      : "color: var(--jha-text-color-secondary, #888); cursor: not-allowed; pointer-events: none;";
  }

  /** BU visibility without a pinned id is invalid — never offer Generate (risk of wrong FI). */
  private isBuScopedTemplateRowMissingPinnedBu(row: WorkflowTemplateType): boolean {
    const cat = String(row.category ?? "").trim().toLowerCase();
    return cat === "businessunit" && !String(row.businessUnitId ?? "").trim();
  }

  private renderGenerateWorkflowMenuItem(row: WorkflowTemplateType) {
    const isActive = stringComparison(row.status?.toUpperCase() ?? "", "ACTIVE");
    const missingPinnedBu = this.isBuScopedTemplateRowMissingPinnedBu(row);
    const canAttemptGenerate = isActive && !missingPinnedBu;
    const generateBlockedTitle = missingPinnedBu
      ? "This template is misconfigured: Business Unit visibility requires a pinned business unit. Contact support. Generate Workflow is disabled."
      : "";
    const linkLabel = isActive
      ? missingPinnedBu
        ? "Generate Workflow (unavailable)"
        : "Generate Workflow"
      : "Inactive Template";
    const linkStyleStr = this.getMenuItemLinkStyle(canAttemptGenerate);
    return html`
      <jha-dropdown-menu-item 
        role="link" 
        data-auto-id="generateWorkflowMenuItem"
        style=${this.getMenuItemStyle(canAttemptGenerate)}
        @click=${(e: Event) => {
        if (!canAttemptGenerate) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        this.onGenerateWorkflowTemplateClick(row);
      }}>
        <a style="${linkStyleStr}" title=${generateBlockedTitle}>${linkLabel}</a>
      </jha-dropdown-menu-item>
    `;
  }

  createColumns() {
    if (this.columns.length) return;

    this.columns = [
      {
        label: "NAME",
        id: "templateName",
        sortBy: true,
        valueRenderer: (val: string) => renderAdvancedTableEllipsisCell(val),
        options: [],
      },
      {
        label: "DESCRIPTION",
        id: "description",
        sortBy: true,
        valueRenderer: (val: string) => renderAdvancedTableEllipsisCell(val),
        options: [],
      },
      {
        label: dateTimeColumnLabel("CREATED ON"),
        id: "createDateTime",
        sortBy: true,
        dataType: "number",
        valueFormatter: () => "",
        valueRenderer: (val: number) => (val > 0 ? formatEpochSecondsForDisplay(val) : "--"),
        options: [],
      },
      {
        label: "CREATED BY",
        id: "createdBy",
        sortBy: true,
        options: [],
      },
      {
        label: dateTimeColumnLabel("UPDATED ON"),
        id: "updateDateTime",
        sortBy: true,
        dataType: "number",
        valueFormatter: () => "",
        valueRenderer: (val: number) => (val > 0 ? formatEpochSecondsForDisplay(val) : "--"),
        options: [],
      },
      {
        label: "UPDATED BY",
        id: "updatedBy",
        sortBy: true,
        options: [],
      },
      {
        label: "VISIBILITY",
        id: "category",
        valueRenderer: (val: string, row: WorkflowTemplateType) => {
          let displayValue: string;
          if (val === "global") {
            displayValue = "Global";
          } else if (val === "businessunit") {
            const buId = (row.businessUnitId || "").toLowerCase();
            displayValue = this.businessUnitsMap.get(buId) || row.businessUnitId || "Business Unit";
          } else {
            displayValue = val || "Unknown";
          }
          return renderAdvancedTableEllipsisCell(displayValue);
        },
        sortBy: true,
        options: [],
      },
      {
        label: "STATUS",
        id: "status",
        sortBy: true,
        valueRenderer: (_val: string, row: any) => html`
          <jha-tooltip
            data-auto-id="statusTooltip${row.templateName}"
            bottom
            text=${stringComparison(row.status?.toUpperCase() ?? "", "ACTIVE")
            ? "Click to Disable Workflow Template"
            : "Click to Enable Workflow Template"}>
            <jha-form-switch
              data-auto-id=${"statusSwitch" + row.templateName}
              ?disabled=${!this.canModifyTemplate(row)}
              ?checked=${stringComparison(row.status?.toUpperCase() ?? "", "ACTIVE")}
              @change=${() => this.updateWorkflowTemplateStatus(row.templateName)}>
            </jha-form-switch>
          </jha-tooltip>
        `,
        options: [],
      },
      {
        id: "_actions",
        label: "",
        valueFormatter: () => "",
        valueRenderer: (_item: any, row: any) => html`
          <jha-dropdown adjustToPageBottom title="Click for Options">
            <jha-dropdown-toggle slot="toggle" tabindex="0" aria-expanded="false" aria-haspopup="true" role="button" data-auto-id="templateActionsMenuToggle">
              <jha-icon-view-more></jha-icon-view-more>
            </jha-dropdown-toggle>
            <jha-dropdown-menu>
              ${!this.isReadOnlyUser ? this.renderGenerateWorkflowMenuItem(row) : nothing}
              <jha-dropdown-menu-item
                role="link"
                data-auto-id="editWorkflowTemplateMenuItem"
                @click=${() =>
            this.onEditWorkflowTemplateClick(
              row.templateName,
              row.status,
              row.category,
              row.businessUnitId
            )}>
                <a>
                  ${this.canEditTemplate(row) ? "Edit Template" : "View Template"}
                </a>
              </jha-dropdown-menu-item>
              ${this.canModifyTemplate(row)
            ? html`
                  <jha-dropdown-menu-item role="link" data-auto-id="deleteWorkflowTemplateMenuItem" @click=${() => this.onDeleteWorkflowTemplateClick(row.templateName)}>
                    <a>Delete Template</a>
                  </jha-dropdown-menu-item>
                 `
            : nothing}
            </jha-dropdown-menu>
          </jha-dropdown>
        `,
        options: [],
      },
    ];
  }

  private boundHandleTemplateUpdated: ((e: Event) => void) | null = null;
  private boundHandleTemplateCreated: ((e: Event) => void) | null = null;

  /**
   * Business Unit Admins only see global templates and templates scoped to their BU.
   * Enterprise Admins see all rows (no filtering).
   */
  private filterTemplatesByAccess(templates: WorkflowTemplateType[]): WorkflowTemplateType[] {
    if (!this.isBusinessUnitAdmin) {
      return templates;
    }
    return filterWorkflowTemplatesForBusinessUnitAdmin(templates, this.loggedUserBu);
  }

  /** True when the row should open in edit (not view-only) for the current user. */
  private canEditTemplate(row: WorkflowTemplateType): boolean {
    if (this.isReadOnlyUser) return false;
    if (stringComparison(row.status?.toUpperCase() ?? "", "ACTIVE")) return false;
    if (this.isBusinessUnitAdmin) {
      return businessUnitAdminCanMutateTemplate(row, this.loggedUserBu);
    }
    return true;
  }

  /** True when delete and status toggle are allowed for this row. */
  private canModifyTemplate(row: WorkflowTemplateType): boolean {
    if (this.isReadOnlyUser) return false;
    if (this.isBusinessUnitAdmin) {
      return businessUnitAdminCanMutateTemplate(row, this.loggedUserBu);
    }
    return true;
  }

  /** Loads BU id -> display name for the Visibility column (same source as WorkflowTemplateSettingsTab). */
  private async loadBusinessUnitsMap() {
    try {
      const response = await getRequest(getEnvApiUrl(Apis.GET_ALL_BUSINESSUNITVALUES));
      const buList = response?.businessUnitValues ?? [];
      const map = new Map<string, string>();
      for (const bu of buList) {
        if (bu.value && bu.name) {
          map.set(String(bu.value).toLowerCase(), bu.name);
        }
      }
      this.businessUnitsMap = map;
    } catch {
      this.businessUnitsMap = new Map();
    }
    this.requestUpdate();
  }

  async connectedCallback() {
    super.connectedCallback();
    this.refreshRoleFromCookies();
    document.title = GlobalVariables.MAIN_TITLE?.concat(" >", this.pageTitle);
    // ACME-1180: Define columns synchronously BEFORE any await so the first
    // render of jha-advanced-table has column definitions. Otherwise the
    // table briefly paints with columns=[] producing a plain-text header
    // row flash above the real header during initial load / hard refresh.
    this.createColumns();
    // Load the BU id->name map before fetching templates so the Visibility column
    // renderer has display names on first paint (third-party table caches column output).
    // [ACME-1576] Set apiLoading before that await so the grid does not flash "No Data to Display".
    this.apiLoading = true;
    await this.loadBusinessUnitsMap();
    await this.getAllMatchingWorkflowTemplates();

    // Listen for template updates from edit view (avoids full re-fetch)
    this.boundHandleTemplateUpdated = this.handleTemplateUpdated.bind(this);
    document.addEventListener("template-updated", this.boundHandleTemplateUpdated);

    // Listen for new template creation (triggers full refresh to get correct sort position)
    this.boundHandleTemplateCreated = this.handleTemplateCreated.bind(this);
    document.addEventListener("template-created", this.boundHandleTemplateCreated);
    this._templatePageSyncTimer = setInterval(() => this.scheduleTemplatePageCatchUp(), 300);
  }

  disconnectedCallback() {
    if (this._templatePageSyncTimer !== undefined) {
      clearInterval(this._templatePageSyncTimer);
      this._templatePageSyncTimer = undefined;
    }
    this.runOnClose();
    if (this.boundHandleTemplateUpdated) {
      document.removeEventListener("template-updated", this.boundHandleTemplateUpdated);
    }
    if (this.boundHandleTemplateCreated) {
      document.removeEventListener("template-created", this.boundHandleTemplateCreated);
    }
    super.disconnectedCallback();
  }

  /**
   * Handle template-updated event from edit view.
   * Updates the specific template in the local array without re-fetching all data.
   */
  private handleTemplateUpdated(e: Event) {
    const detail = (e as CustomEvent).detail;
    if (!detail?.templateName) return;

    const index = this.workflowTemplates.findIndex(
      (t) => t.templateName === detail.templateName
    );
    if (index !== -1) {
      // Update the specific template with new data
      this.workflowTemplates = [
        ...this.workflowTemplates.slice(0, index),
        { ...this.workflowTemplates[index], ...detail },
        ...this.workflowTemplates.slice(index + 1),
      ];
      // BU admins: drop rows that are no longer visible (e.g. category/BU changed away from their scope)
      if (this.isBusinessUnitAdmin) {
        this.workflowTemplates = this.filterTemplatesByAccess(
          this.workflowTemplates as WorkflowTemplateType[]
        ).map((t) => ({ ...t, _actions: true })) as any;
      }
    }
  }

  /**
   * Handle template-created event from add view.
   * Refreshes the full list to ensure proper sorting and display of the new template.
   */
  private handleTemplateCreated(_e: Event) {
    this.getAllMatchingWorkflowTemplates(this.templateSearchName);
  }

  private runOnClose() {
    // Cleanup handled automatically by Environment configuration
  }

  async onGenerateWorkflowTemplateClick(row: WorkflowTemplateType) {
    try {
      if (this.isReadOnlyUser) {
        return;
      }
      // 1. Fetch full template entity (variables are nested inside)
      const templateData = await getRequest(`${Apis.GET_WORKFLOW_TEMPLATE}/${row.templateName}`);

      if (!templateData) {
        return;
      }
      if (templateData?.details?.length > 0) {
        showToastMessage("Failed to load template.", "danger");
        return;
      }

      const templateCategoryNorm = String(templateData.category ?? "").trim().toLowerCase();
      const templateBuIdNorm = String(templateData.businessUnitId ?? "").trim();
      if (templateCategoryNorm === "businessunit" && !templateBuIdNorm) {
        showToastMessage(
          "This template cannot be used to generate a workflow: it is scoped to a business unit but none is set. Please contact support.",
          "danger"
        );
        return;
      }

      if (
        this.isBusinessUnitAdmin &&
        !businessUnitAdminCanGenerateFromTemplate(templateData, this.loggedUserBu)
      ) {
        showToastMessage("You do not have permission to generate a workflow from this template.", "danger");
        return;
      }

      // Extract variables from template entity (camelCase to match API), plus built-in S3 Remote region
      // (conditional: only when steps reference {BUILTIN_REGION_VARIABLE}) and the built-in Business
      // Unit variable (always injected; the Generate dialog renders a BU dropdown for every template).
      const fromApi = (templateData.variables || []) as WorkflowTemplateVariable[];
      const variablesForGenerate: WorkflowTemplateVariable[] = fromApi
        .map(mergeBuiltinRegionVariableForGenerateUi)
        .map(mergeBuiltinBusUnitVariableForGenerateUi);
      const existingNames = new Set(
        variablesForGenerate.map((v) => (v.name || "").toLowerCase())
      );
      if (
        templateEntityUsesBuiltinRegionVariable(templateData) &&
        !existingNames.has(BUILTIN_REGION_VARIABLE.toLowerCase())
      ) {
        variablesForGenerate.push({ ...getSyntheticBuiltinRegionVariableForApi() });
      }
      if (!existingNames.has(BUILTIN_BUSUNIT_VARIABLE.toLowerCase())) {
        variablesForGenerate.push({ ...getSyntheticBuiltinBusUnitVariableForApi() });
      }

      // BUILTIN_BUSUNIT_VARIABLE is always present (synthetic or template-declared) and is the
      // first decision a user makes when generating a workflow, so render it as the first
      // control in the dialog regardless of the template's declared variable order.
      const busUnitIndex = variablesForGenerate.findIndex(
        (v) => (v.name || "").toLowerCase() === BUILTIN_BUSUNIT_VARIABLE.toLowerCase()
      );
      if (busUnitIndex > 0) {
        const [busUnitVariable] = variablesForGenerate.splice(busUnitIndex, 1);
        variablesForGenerate.unshift(busUnitVariable);
      }

      // 2. Create the form element (component renders its own <jha-dialog>)
      // The dialog handles the API call internally and shows success/error
      const templateBusinessUnitId = templateData.businessUnitId ?? null;
      const templateBusinessUnitName = templateBusinessUnitId
        ? this.businessUnitsMap.get(String(templateBusinessUnitId).toLowerCase()) ?? ""
        : "";

      const formElement = document.createElement("workflow-template-generate-dialog") as any;
      formElement.templateName = row.templateName;
      formElement.variables = variablesForGenerate;
      formElement.transferType = templateData.transferType || ""; // Pass transfer type for path construction
      formElement.templateCategory = templateData.category ?? "";
      formElement.templateBusinessUnitId = templateBusinessUnitId;
      formElement.templateBusinessUnitName = templateBusinessUnitName;

      // 3. Open dialog - it handles API call, shows result, then closes
      const result = await DialogUtil.awaitDialog({
        dialog: formElement,
      });

      // 4. Dialog closed - result contains { workflowName } on success, null on cancel/error
      if (result?.workflowName) {
        // Workflow was created successfully - dialog already showed success message
        // Optional: Navigate to the new workflow
        // AppRouters.go(`/workflows/edit-workflow/${result.workflowName}`);
      }
      // If result is null, user canceled or there was an error (dialog handled messaging)

    } catch (error) {
      // Dialog was closed via rejection (user canceled)
      // Silent - this is expected behavior
    }
  }

  onAddWorkflowTemplateClick() {
    AppRouters.go(`/workflow-templates/add-workflow-template`);
  }

  // Both the view and edit templates are the same page, so we need to check the
  // status to determine which page to route to.
  onEditWorkflowTemplateClick(
    workflowTemplateId: string,
    status?: string,
    category?: string,
    businessUnitId?: string | null
  ) {
    const isTemplateActive = stringComparison(status?.toUpperCase() ?? "", "ACTIVE");
    const buAdminCannotEdit =
      this.isBusinessUnitAdmin &&
      !businessUnitAdminCanMutateTemplate({ category, businessUnitId }, this.loggedUserBu);

    // Use the started AppRouters singleton (same as onAddWorkflowTemplateClick), not a
    // fresh `new Router()`. An unstarted router has no handlers, so go() falls back to
    // window.location.href — a full page reload that briefly flashes the login shell.
    if (this.isReadOnlyUser || isTemplateActive || buAdminCannotEdit) {
      AppRouters.go(`/workflow-templates/view-workflow-template/${workflowTemplateId}`);
    } else {
      AppRouters.go(`/workflow-templates/edit-workflow-template/${workflowTemplateId}`);
    }
  }

  onSearchTemplateNameChange(e: { target: { value: string } }) {
    this.templateSearchName = e.target.value;
  }

  async onSearchTemplateClear() {
    this.templateSearchName = "";
    await this.getAllMatchingWorkflowTemplates();
  }

  onSearchTemplateClick() {
    this.templateSearchName = this.templateSearchName.trimStart().trimEnd();
    if (this.templateSearchName.length > 0) {
      this.getAllMatchingWorkflowTemplates(this.templateSearchName);
    } else {
      this.getAllMatchingWorkflowTemplates();
    }
  }

  onSearchTemplateKeyDown(e: KeyboardEvent) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onSearchTemplateClick();
    } else if (e.key === "Escape") {
      e.preventDefault();
      this.onSearchTemplateClear();
    }
  }

  async onDeleteWorkflowTemplateClick(templateName: string) {
    const result = await openJhftDialog({
      variant: "danger",
      title: "Delete Workflow Template",
      message:
        "Are you sure you want to delete this workflow template? Existing workflows generated from this template will not be affected.",
      cancelLabel: "Cancel",
      confirmLabel: "Delete",
    });
    if (result !== "confirm") {
      return false;
    }
    await this.deleteWorkflowTemplate(templateName);
    return true;
  }

  protected updateStatusTooltip(workflowTemplateId: string, status: string) {
    //Implement update tooltip text based on status
    const table = this.shadowRoot?.querySelector("jha-advanced-table");

    let statusTooltip: HTMLElement | null = null;
    if (table && (table as any).shadowRoot) {
      statusTooltip = (table as any).shadowRoot.querySelector(`jha-tooltip[data-auto-id='statusTooltip${workflowTemplateId}']`);
      if (statusTooltip) {
        statusTooltip.setAttribute(
          "text",
          status === "Active" ? "Click to Disable Workflow Template" : "Click to Enable Workflow Template"
        );
      }
    }
  }

  async updateWorkflowTemplateStatus(templateName: string) {
    if (this.isReadOnlyUser) {
      return;
    }

    const row = this.workflowTemplates.find((t) => t.templateName === templateName);
    this.apiLoading = true;

    try {
      const templateData = await getRequest(Apis.GET_WORKFLOW_TEMPLATE + `/` + templateName);

      if (!templateData) {
        if (row) {
          this.updateStatusTooltip(templateName, row.status ?? "");
        }
        return;
      }

      if (templateData?.details?.length > 0) {
        showToastMessage("Unable to retrieve workflow template.", "danger");
        if (row) {
          this.updateStatusTooltip(templateName, row.status ?? "");
        }
        return;
      }

      if (this.isBusinessUnitAdmin && !businessUnitAdminCanMutateTemplate(templateData, this.loggedUserBu)) {
        showToastMessage("You do not have permission to change status for this template.", "danger");
        if (row) {
          this.updateStatusTooltip(templateName, row.status ?? "");
        }
        return;
      }

      const currentStatus = templateData.status?.toUpperCase();
      const updatedStatus = currentStatus === "ACTIVE" ? "inactive" : "active";

      const request = {
        status: updatedStatus,
        templateName: templateName,
      };

      const updateResponse = await putRequest<{ status: string; templateName: string }>(
        Apis.UPDATE_WORKFLOW_TEMPLATE_STATUS,
        templateData.eTag,
        request
      );

      if (!updateResponse) {
        if (row) {
          this.updateStatusTooltip(templateName, row.status ?? "");
        }
        return;
      }

      if (updateResponse.messageStatus === null) {
        const templateIndex = this.workflowTemplates.findIndex((t: any) => t.templateName === templateName);
        if (templateIndex !== -1) {
          this.workflowTemplates[templateIndex].status = updatedStatus;
          this.workflowTemplates = [...this.workflowTemplates];
        }

        this.updateStatusTooltip(templateName, updatedStatus);
        showToastMessage("Workflow Template status updated successfully.", "success");
      } else if (updateResponse?.details?.length > 0) {
        const errMsg = getErrorMessage(updateResponse.details);
        showToastMessage(errMsg, "danger");
      } else {
        showToastMessage("Something went wrong, please try again.", "danger");
      }
    } catch {
      if (row) {
        this.updateStatusTooltip(templateName, row.status ?? "");
      }
    } finally {
      this.apiLoading = false;
    }
  }

  /**
   * Fetch workflow templates with search, sort, and pagination support
   *
   * This method is called when:
   * 1. Component initializes (loads first page)
   * 2. User changes sort order (resets to page 1 with new sort)
   * 3. User searches (resets to page 1 with search filter)
   *
   * The backend API receives:
   * - templateName: search filter
   * - sortColumn: column to sort by
   * - sortDescending: sort direction (true = descending, false = ascending)
   * - pageKey: pagination offset (undefined for first page)
   *
   * @param rawSearchTemplate - Optional search term to filter templates
   */
  /**
   * Returns false when jha-fetch already showed the network toast (offline / failed POST).
   * Callers should not chain another getRequest in that case or the user sees two identical toasts.
   */
  async getAllMatchingWorkflowTemplates(rawSearchTemplate?: string | null): Promise<boolean> {
    const searchTemplate = rawSearchTemplate == null ? "" : rawSearchTemplate.trim();
    this.nextPageKey = "";
    void this.resetTemplateTablePageOffset();
    this.apiLoading = true;
    this.searchWorkflowTemplate = true;

    try {
      const reqParams: WorkflowTemplateSearchRequest = {
        templateName: searchTemplate,
      };

      if (this.advancedTableConfig.sort) {
        reqParams.sortColumn = this.advancedTableConfig.sort.columnId;
        reqParams.sortDescending = this.advancedTableConfig.sort.descending;
      }

      const response = await postRequest<WorkflowTemplateSearchRequest>(Apis.SEARCH_WORKFLOW_TEMPLATE, reqParams);

      if (!response) {
        this.workflowTemplates = [];
        this.advancedTableConfig.apiTotal = 0;
        this.nextPageKey = "";
        return false;
      }

      if (typeof Response !== "undefined" && response instanceof Response) {
        this.workflowTemplates = [];
        this.advancedTableConfig.apiTotal = 0;
        this.nextPageKey = "";
        return false;
      }

      if (response?.messageStatus === null) {
        const templates = Array.isArray(response?.results) ? response.results : [];
        const filtered = this.filterTemplatesByAccess(templates);

        this.workflowTemplates = filtered.map((t: WorkflowTemplateType) => ({ ...t, _actions: true }));
        this.advancedTableConfig.apiTotal = this.isBusinessUnitAdmin
          ? filtered.length
          : (response?.totalCount ?? templates.length);

        this.nextPageKey = response?.pageKey ?? "";
        return true;
      } else if (response?.status === StatusConstants.NOT_FOUND_WORKFLOW_TEMPLATE_CODE) {
        this.workflowTemplates = [];
        this.advancedTableConfig.apiTotal = 0;
        this.nextPageKey = "";
        return true;
      } else if (response?.details?.length > 0) {
        const errMsg = getErrorMessage(response.details);
        showToastMessage(errMsg, "danger");
        return true;
      } else {
        showToastMessage("Something went wrong, please try again.", "danger");
        return true;
      }
    } catch {
      return false;
    } finally {
      this.apiLoading = false;
      this.searchWorkflowTemplate = false;
    }
  }

  async deleteWorkflowTemplate(templateName: string) {
    this.apiLoading = true;
    try {
      const templateData = await getRequest(Apis.GET_WORKFLOW_TEMPLATE + `/` + templateName);

      if (!templateData) {
        return;
      }

      if (templateData?.details?.length > 0) {
        showToastMessage("Could not retrieve workflow template details.", "danger");
        return;
      }

      if (this.isBusinessUnitAdmin && !businessUnitAdminCanMutateTemplate(templateData, this.loggedUserBu)) {
        showToastMessage("You do not have permission to delete this template.", "danger");
        return;
      }

      const deleteResponse = await deleteRequest(
        `${Apis.DELETE_WORKFLOW_TEMPLATE}/${fixedEncodeURIComponent(templateName)}`,
        templateData.eTag
      );

      if (!deleteResponse) {
        return;
      }

      if (deleteResponse?.status === StatusConstants.DELETE_WORKFLOW_TEMPLATE_SUCCESS_CODE) {
        showToastMessage(`Workflow Template "${templateName}" deleted successfully.`, "success");
        const deleteIndex = this.workflowTemplates.findIndex((x: any) => x.templateName === templateName);
        if (deleteIndex > -1) {
          this.workflowTemplates.splice(deleteIndex, 1);
          this.advancedTableConfig.apiTotal = Math.max(0, (this.advancedTableConfig.apiTotal ?? 0) - 1);
          this.requestUpdate();
        }
        await this.getAllMatchingWorkflowTemplates(this.templateSearchName);
      } else if (!deleteResponse?.ok) {
        try {
          const errorData = await deleteResponse?.json();
          if (errorData?.details?.length > 0) {
            const errMsg = getErrorMessage(errorData.details);
            showToastMessage(errMsg, "danger");
          } else {
            showToastMessage("Failed to delete workflow template.", "danger");
          }
        } catch {
          showToastMessage("Failed to delete workflow template.", "danger");
        }
      } else {
        showToastMessage("Something went wrong, please try again.", "danger");
      }
    } finally {
      this.apiLoading = false;
    }
  }

  /**
   * Fetch next page of workflow templates
   *
   * CRITICAL: This method MUST include the same sort and filter parameters
   * as the initial request to maintain consistent ordering across pages.
   *
   * The backend will:
   * 1. Apply the same filter (templateName)
   * 2. Apply the same sort (sortColumn, sortDescending)
   * 3. Return the next page based on pageKey offset
   *
   * This ensures pagination respects the current sort order.
   */
  async fetchNextPageData() {
    this.apiLoading = true;

    try {
      const request: WorkflowTemplateSearchRequest = {
        templateName: this.templateSearchName || "",
        pageKey: this.nextPageKey,
      };

      if (this.advancedTableConfig.sort) {
        request.sortColumn = this.advancedTableConfig.sort.columnId;
        request.sortDescending = this.advancedTableConfig.sort.descending;
      }

      const response = await postRequest<WorkflowTemplateSearchRequest>(Apis.SEARCH_WORKFLOW_TEMPLATE, request);

      if (!response) {
        this.nextPageKey = "";
        return;
      }

      if (typeof Response !== "undefined" && response instanceof Response) {
        this.nextPageKey = "";
        return;
      }

      if (response?.messageStatus === null) {
        const nextData = response?.results ?? [];
        this.workflowFetchedTemplateData = [...nextData];
        this.nextPageKey = response?.pageKey ?? "";
      } else if (response?.details?.length > 0) {
        const errMsg = getErrorMessage(response.details);
        showToastMessage(errMsg, "danger");
      } else {
        showToastMessage("Something went wrong, please try again.", "danger");
      }
    } catch {
    } finally {
      this.apiLoading = false;
    }
  }

  private rowsNeededForTablePage(pageOffset: number): number {
    const total = this.advancedTableConfig?.apiTotal ?? 0;
    if (!total) {
      return 0;
    }
    const limit = this.pageLimit;
    const endExclusive = pageOffset * limit + limit;
    return Math.min(total, endExclusive);
  }

  private enqueueTemplatePagedOp(op: () => Promise<void>): Promise<void> {
    const next = this._templatePagedFetchChain.then(op).catch(() => { });
    this._templatePagedFetchChain = next;
    return next;
  }

  /** Loads template-search pages until workflowTemplates covers the pager's current page. */
  private scheduleTemplatePageCatchUp() {
    if (this.searchWorkflowTemplate) {
      return;
    }
    const table = this.shadowRoot?.querySelector("jha-advanced-table") as { pageOffset?: number } | null;
    if (!table) {
      return;
    }
    const pageOffset = table.pageOffset ?? 0;
    const needed = this.rowsNeededForTablePage(pageOffset);
    if (needed <= 0 || this.workflowTemplates.length >= needed || !this.nextPageKey) {
      return;
    }
    void this.enqueueTemplatePagedOp(async () => {
      this.loadingMore = true;
      this.apiLoading = true;
      try {
        while (!this.searchWorkflowTemplate) {
          const t = this.shadowRoot?.querySelector("jha-advanced-table") as { pageOffset?: number } | null;
          const off = t?.pageOffset ?? 0;
          const need = this.rowsNeededForTablePage(off);
          if (need <= 0 || this.workflowTemplates.length >= need || !this.nextPageKey) {
            break;
          }
          const remaining = need - this.workflowTemplates.length;
          const batchCount = Math.min(
            Math.max(remaining, this.pageLimit),
            WorkflowTemplateMainView.TEMPLATE_SEEK_MAX_COUNT,
          );
          let fetched = 0;
          while (fetched < batchCount && this.nextPageKey) {
            await this.fetchNextPageData();
            const pageRows = this.filterTemplatesByAccess(this.workflowFetchedTemplateData);
            const newData = pageRows.map((t: WorkflowTemplateType) => ({ ...t, _actions: true }));
            this.workflowTemplates = [...this.workflowTemplates, ...newData];
            fetched += pageRows.length;
            if (!pageRows.length) {
              break;
            }
          }
        }
      } finally {
        this.loadingMore = false;
        this.apiLoading = false;
      }
    });
  }

  private async resetTemplateTablePageOffset() {
    const table = this.renderRoot?.querySelector("jha-advanced-table") as
      | { pageOffset?: number; handleTableResize?: () => Promise<void> }
      | null;
    if (!table) {
      return;
    }
    table.pageOffset = 0;
    if (table.handleTableResize) {
      await table.handleTableResize();
    }
  }

  private async syncTemplateAdvancedTableAfterPaging() {
    const table = this.renderRoot.querySelector("jha-advanced-table") as
      | { handleTableResize?: () => Promise<void> }
      | null;
    if (table?.handleTableResize) {
      await table.handleTableResize();
    }
    requestAnimationFrame(() => this.injectAdvancedTableStyles());
  }

  private ensureTemplateTablePaginationScrollSync() {
    if (this._templateTablePaginationSyncBound) {
      return;
    }
    const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
    const root = table?.shadowRoot;
    if (!table || !root) {
      return;
    }
    this._templateTablePaginationSyncBound = true;
    table.addEventListener("page-limit-change", () => {
      void this.syncTemplateAdvancedTableAfterPaging();
    });
    root.addEventListener(
      "click",
      (e: Event) => {
        const popover = root.querySelector("jha-popover#pager");
        if (!popover || !e.composedPath().includes(popover)) {
          return;
        }
        const target = e.target as HTMLElement | null;
        if (!target || target.tagName !== "BUTTON") {
          return;
        }
        const openSlot = popover.querySelector('[slot="button"]');
        if (openSlot && (target === openSlot || openSlot.contains(target))) {
          return;
        }
        void this.syncTemplateAdvancedTableAfterPaging();
      },
      false,
    );
  }

  async handleLoadMore() {
    if (this.advancedTableConfig.apiControlled && this.nextPageKey !== "") {
      this.loadingMore = true;
      await this.fetchNextPageData();
      const filteredPage = this.filterTemplatesByAccess(this.workflowFetchedTemplateData);
      // Add _actions property to each row for the actions column (grid requires data binding)
      const newData = filteredPage.map((t: WorkflowTemplateType) => ({ ...t, _actions: true }));
      this.workflowTemplates = [...this.workflowTemplates, ...newData];
      this.loadingMore = false;
    }
  }

  /**
   * Handle table update events from jha-advanced-table
   *
   * Event Structure:
   * - event.type = "table-update" (the event type)
   * - event.detail.type = "sort" (indicates this is a sort update)
   * - event.detail.config = the updated table config
   * - event.detail.config.sort = { columnId: string, descending: boolean }
   *
   * When user clicks a column header to sort:
   * 1. Extract the new sort configuration from the event
   * 2. Update advancedTableConfig with the new sort
   * 3. Reset pagination to page 1 (nextPageKey = "")
   * 4. Fetch page 1 with the new sort order
   *
   * This ensures:
   * - The entire dataset is sorted on the backend
   * - Pagination starts from the beginning of the sorted dataset
   * - All subsequent pages respect the new sort order
   */
  async handleTableUpdate(event: any) {
    requestAnimationFrame(() => this.injectAdvancedTableStyles());
    const eventDetail = event.detail;

    // Check if this is a sort update
    if (eventDetail && eventDetail.type === "sort" && eventDetail.config) {
      const sortConfig = eventDetail.config.sort;

      // Validate sort configuration
      if (sortConfig && sortConfig.columnId) {
        // Update the table config with the new sort
        this.advancedTableConfig = {
          ...this.advancedTableConfig,
          sort: {
            columnId: sortConfig.columnId,
            descending: sortConfig.descending === true,
          },
        };

        // CRITICAL: Reset pagination when sort changes
        // This ensures we start from page 1 of the newly sorted dataset
        this.nextPageKey = "";
        void this.resetTemplateTablePageOffset();

        // Trigger Lit update cycle
        this.requestUpdate();

        // Fetch page 1 with new sort order
        // The backend will sort the ENTIRE dataset and return page 1
        await this.getAllMatchingWorkflowTemplates(this.templateSearchName);
      }
    }
    requestAnimationFrame(() => this.injectAdvancedTableStyles());
  }

  get templateGridRows() {
    const rows = this.workflowTemplates.map((row) => ({
      ...row,
      createDateTime: normalizeEpochSeconds(row.createDateTime),
      updateDateTime: normalizeEpochSeconds(row.updateDateTime),
    }));
    const sort = this.advancedTableConfig?.sort;
    return orderLoadedRowsByEpoch(rows, sort?.columnId, sort?.descending, [
      "createDateTime",
      "updateDateTime",
    ]);
  }

  renderTable() {
    return html`
      <jha-advanced-table
        style=${EFM_TIMEZONE_GRID_TABLE_STYLE}
        data-auto-id="workflowTemplateTable"
        .data=${this.templateGridRows as Array<{ selected?: boolean; checkboxColor?: string }>}
        .pageLimit=${this.pageLimit}
        .allowPageChange=${true}
        .allowPageLimitChange=${true}
        .tableConfig=${this.advancedTableConfig}
        .columns=${this.columns as unknown as any}
        .loadingMore=${this.loadingMore}
        .fullWidthColumns=${true}
        .loading=${this.searchWorkflowTemplate}
        .noContentMessage=${"No Data to Display"}
        @pagination-forward=${this.handleLoadMore}
        @table-update=${this.handleTableUpdate}>
      </jha-advanced-table>
    `;
  }

  updated(changed: PropertyValues) {
    super.updated?.(changed);
    const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
    if (table) {
      table.toggleAttribute(
        "data-api-loading",
        this.apiLoading || this.searchWorkflowTemplate || this.loadingMore,
      );
      table.toggleAttribute("data-has-data", this.workflowTemplates.length > 0);
    }
    requestAnimationFrame(() => {
      this.injectAdvancedTableStyles();
      this.ensureTemplateTablePaginationScrollSync();
    });
  }

  private injectAdvancedTableStyles() {
    const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
    const root = table?.shadowRoot;
    if (!root) return;
    const css = `
            ${ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT}
            ${EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT}
            ${jhaDropdownMenuPanelStylesText}
            .loading jh-progress { visibility: hidden; }
            :host([data-api-loading]) .no-content,
            :host([data-has-data]) .no-content { visibility: hidden; }
            .no-content p {
                font-size: 20px;
                font-weight: 600;
                margin: 0;
            }
            ${buildAdvancedTableEllipsisColumnShadowCss([
      "templateName",
      "description",
      "category",
    ])}
            ${buildAdvancedTableJhaTooltipOverflowEscapeCss(["status"])}
        `;
    let style = root.querySelector("style[data-acme-1180]") as HTMLStyleElement | null;
    if (!style) {
      style = document.createElement("style");
      style.setAttribute("data-acme-1180", "");
      root.appendChild(style);
    }
    style.textContent = css;
    applyAdvancedTableHeaderLayout(root);
    stripAdvancedTableRedundantTitles(
      root,
      WORKFLOW_TEMPLATE_ELLIPSIS_TITLE_COLUMN_IDS,
      WORKFLOW_TEMPLATE_PRESERVE_INNER_TITLE_COLUMN_IDS,
    );
  }

  render() {
    return html`
      <slot>
        ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
        <div id="workflowTemplatesMain">
          <div id="formCon">
            <h1>Workflow Templates</h1>
            <div class="inputContainer">
              <jh-tooltip position="bottom-start" label="Search by Workflow Template Name">
                <jh-input
                  show-clear-button
                  data-auto-id="searchTemplateNameInput"
                  .placeholder=${"Search"}
                  @jh-clear=${this.onSearchTemplateClear}
                  .value=${this.templateSearchName}
                  @input=${this.onSearchTemplateNameChange}
                  @keydown=${this.onSearchTemplateKeyDown}
                  maxlength="256">
                </jh-input>
              </jh-tooltip>
              <jha-button sync type="button" icon data-auto-id="searchTemplateBtn" @click=${this.onSearchTemplateClick}>
                <jha-icon-search></jha-icon-search>
              </jha-button>
              ${this.isReadOnlyUser
        ? nothing
        : html`
              <jha-tooltip bottom text="Click to add new Workflow Template">
                <jha-button
                  data-auto-id="addWorkflowTemplateBtn"
                  type="button"
                  primary
                  large
                  sync
                  @click=${this.onAddWorkflowTemplateClick}>
                  <jha-icon-plus slot="icon-left"></jha-icon-plus>Add Workflow Template
                </jha-button>
              </jha-tooltip>
              `}
            </div>
          </div>
          <jha-card
            >${renderGridWithTimezoneBanner(this.renderTable())}</jha-card
          >
        </div>
      </slot>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "workflow-template-main-view": WorkflowTemplateMainView;
  }
}
